
      import Toast from 'uni-platform/components/app/popup/toast.vue'
import PreviewImage from 'uni-platform/components/app/popup/preview-image/index.vue'
import Modal from 'uni-platform/components/app/popup/modal.vue'
      export default {
        Toast,
PreviewImage,
Modal
      }
      